import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useContext } from 'react';

var OverlayIds;
(function (OverlayIds) {
    OverlayIds["ADD_NEW_CARD"] = "ADD_NEW_CARD";
    OverlayIds["DELETE_CARD"] = "DELETE_CARD";
    OverlayIds["DELETE_CARD_NEW"] = "DELETE_CARD_NEW";
    OverlayIds["DELETE_ALL_CARDS"] = "DELETE_ALL_CARDS";
    OverlayIds["BANCONTACT_MOBILE_AUTH"] = "BANCONTACT_MOBILE_AUTH";
    OverlayIds["ADYEN_CREDIT_CARD_AUTH"] = "ADYEN_CREDIT_CARD_AUTH";
})(OverlayIds || (OverlayIds = {}));
const OverlaysContext = createContext({
    hideOverlay: () => null,
    showOverlay: () => null,
    checkIsActive: () => false,
});
const OverlaysProvider = ({ children }) => {
    const [overlays, setOverlays] = useState({});
    const hideOverlay = useCallback((id) => {
        setOverlays((previousOverlays) => ({ ...previousOverlays, [id]: { isActive: false } }));
    }, []);
    const showOverlay = useCallback((id) => {
        setOverlays((previousOverlays) => ({ ...previousOverlays, [id]: { isActive: true } }));
    }, []);
    const checkIsActive = useCallback((id) => {
        return !!overlays[id]?.isActive;
    }, [overlays]);
    return (jsx(OverlaysContext.Provider, { value: {
            hideOverlay,
            showOverlay,
            checkIsActive,
        }, children: children }));
};
const useOverlays = () => {
    return useContext(OverlaysContext);
};

export { OverlayIds, OverlaysContext, OverlaysProvider as default, useOverlays };
//# sourceMappingURL=OverlaysProvider.js.map
